<template>
    <div class="main">
        <div>
            <div
                id="container"
                class="mymap"
                style="width: 100%; height: 100%"
            ></div>
            <div class="superLeft">
                <div class="oldBox superBox">
                    <div class="leftTitle">养老机构统计</div>
                    <!-- 床位数 -->
                    <div id="beds"></div>
                    <div class="borderLine"></div>
                    <!-- 机构评级覆盖率 -->
                    <div id="mechanism"></div>
                    <div class="borderLine"></div>
                    <!-- 医养结合覆盖率 -->
                    <div id="combination"></div>
                </div>
            </div>
            <div class="superRight">
                <div class="rightBox">
                    <div class="rightChart">
                        <div class="oldBox jgBox">
                            <div class="leftTitle">
                                养老机构入住率<span style="font-size: 16px"
                                    >(45%)</span
                                >
                            </div>
                            <p class="chartTitles"></p>
                            <div class="chartBox">
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress1">
                                        <div id="num" class="num"></div>
                                        <div class="wave wave1"></div>
                                        <div
                                            id="wave-mask"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum0 }}
                                    </p>
                                    <p class="waveTitle waveTitle1">
                                        <!-- {{ mechanism0 }} -->
                                        华阳镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress2">
                                        <div id="num1" class="num"></div>
                                        <div class="wave wave2"></div>
                                        <div
                                            id="wave-mask1"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum1 }}
                                    </p>
                                    <p class="waveTitle waveTitle2">
                                        <!-- {{ mechanism1 }} -->
                                        临溪镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress3">
                                        <div id="num2" class="num"></div>
                                        <div class="wave wave3"></div>
                                        <div
                                            id="wave-mask2"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum2 }}
                                    </p>
                                    <p class="waveTitle waveTitle3">
                                        <!-- {{ mechanism2 }} -->
                                        长安镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num3" class="num"></div>
                                        <div class="wave wave4"></div>
                                        <div
                                            id="wave-mask3"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum3 }}
                                    </p>
                                    <p class="waveTitle waveTitle4">
                                        <!-- {{ mechanism3 }} -->
                                        上庄镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num4" class="num"></div>
                                        <div class="wave wave1"></div>
                                        <div
                                            id="wave-mask4"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum4 }}
                                    </p>
                                    <p class="waveTitle waveTitle1">
                                        <!-- {{ mechanism3 }} -->
                                        扬溪镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num5" class="num"></div>
                                        <div class="wave wave2"></div>
                                        <div
                                            id="wave-mask5"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum5 }}
                                    </p>
                                    <p class="waveTitle waveTitle2">
                                        <!-- {{ mechanism3 }} -->
                                        板桥头乡
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num6" class="num"></div>
                                        <div class="wave wave3"></div>
                                        <div
                                            id="wave-mask6"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum6 }}
                                    </p>
                                    <p class="waveTitle waveTitle3">
                                        <!-- {{ mechanism3 }} -->
                                        金沙镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num7" class="num"></div>
                                        <div class="wave wave4"></div>
                                        <div
                                            id="wave-mask7"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum7 }}
                                    </p>
                                    <p class="waveTitle waveTitle4">
                                        <!-- {{ mechanism3 }} -->
                                        伏岭镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num8" class="num"></div>
                                        <div class="wave wave1"></div>
                                        <div
                                            id="wave-mask8"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum8 }}
                                    </p>
                                    <p class="waveTitle waveTitle1">
                                        <!-- {{ mechanism3 }} -->
                                        家朋乡
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num9" class="num"></div>
                                        <div class="wave wave2"></div>
                                        <div
                                            id="wave-mask9"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum9 }}
                                    </p>
                                    <p class="waveTitle waveTitle2">
                                        <!-- {{ mechanism3 }} -->
                                        荆州乡
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num10" class="num"></div>
                                        <div class="wave wave3"></div>
                                        <div
                                            id="wave-mask10"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum10 }}
                                    </p>
                                    <p class="waveTitle waveTitle3">
                                        <!-- {{ mechanism3 }} -->
                                        龙川中心
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="oldBox rzBox heBox">
                            <div class="leftTitle">入住老人能力评估</div>
                            <div id="huli"></div>
                            <div id="lodLiveEcharts" ref="lodLiveEcharts"></div>
                        </div>
                    </div>
                    <div class="rightTable">
                        <div class="mechanismNum">
                            <div class="mechanismItem">
                                <p class="name">养老机构</p>
                                <p class="nums">
                                    <img
                                        src="./assets/big/jigou2.png"
                                        class="imgs"
                                        alt=""
                                        srcset=""
                                    /><span>11</span>家
                                </p>
                            </div>
                            <div class="mechanismItem">
                                <p class="name">总床位数</p>
                                <p class="nums">
                                    <img
                                        src="./assets/big/jigou1.png"
                                        class="imgs"
                                        alt=""
                                        srcset=""
                                    /><span> 646 </span>张
                                </p>
                            </div>
                            <div class="mechanismItem2">
                                <p class="name">养老机构护理型床位占比</p>
                                <p class="nums">
                                    <img
                                        src="./assets/big/jigou3.png"
                                        class="imgs"
                                        alt=""
                                        srcset=""
                                    /><span>
                                        <!-- 80% -->
                                        45%
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="oldBox rzBoxs">
                            <div class="leftTitle">入住老人信息</div>
                            <div class="houseBox">
                                <div
                                    class="houseList"
                                    v-if="tableList.length > 0"
                                >
                                    <div class="houseBar">
                                        <p class="names">姓名</p>
                                        <!-- <p class="ages">年龄</p> -->
                                        <p class="sex">性别</p>
                                        <!-- <p class="times">身体状况</p> -->
                                        <p class="level">失能等级</p>
                                        <p class="mechanisms">地址</p>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                        @click="showInfo($event)"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tableList"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="houseItem"
                                                v-for="(
                                                    item, index
                                                ) in tableList"
                                                :key="index"
                                            >
                                                <p
                                                    class="names"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.customerName }}
                                                </p>
                                                <!-- <p class="ages" :data-obj="JSON.stringify(item)">
                          {{ item.age }}
                        </p> -->
                                                <p
                                                    class="sex"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.gender }}
                                                </p>
                                                <!-- <p class="times" :data-obj="JSON.stringify(item)">
                            {{ item.conditional }}
                          </p> -->
                                                <p
                                                    class="level"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '自理'
                                                        "
                                                        class="color2"
                                                        >自理</span
                                                    >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '半自理'
                                                        "
                                                        class="color1"
                                                        >半自理</span
                                                    >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '不能自理'
                                                        "
                                                        class="color3"
                                                        >不能自理</span
                                                    >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '半失能'
                                                        "
                                                        class="color4"
                                                        >半失能</span
                                                    >
                                                </p>
                                                <p
                                                    class="mechanisms"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.address }}
                                                </p>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="oldBox safeBox">
                            <div class="leftTitle">安全检查列表</div>
                            <div class="houseBox">
                                <div
                                    class="houseList"
                                    v-if="insList.length > 0"
                                >
                                    <div class="houseBar flexs">
                                        <p class="names">巡检名称</p>
                                        <p class="ages">设置时限</p>
                                        <!-- <p class="sex">巡检机构</p> -->
                                        <p class="times">巡检人员</p>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 60vh; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="insList"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="houseItem flexs"
                                                v-for="(item, index) in insList"
                                                :key="index"
                                            >
                                                <p
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.insName }}
                                                </p>
                                                <p
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.startTime }}-{{
                                                        item.endTime
                                                    }}
                                                </p>
                                                <!-- <p  :data-obj="JSON.stringify(item)">
                            {{ item.insOrgName }}
                          </p> -->
                                                <p
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.insPersonName }}
                                                </p>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 机构信息弹窗 -->
            <div class="mechanism_info" v-show="mechanism">
                <div class="mechanismName">{{ info.name }}</div>
                <div class="x" @click="close">x</div>
                <div class="content1">
                    <div
                        class="btnGroup"
                        style="display: flex; justify-content: space-between"
                    >
                        <div
                            style="
                                display: flex;
                                margin: 10px 0;
                                font-size: 20px;
                            "
                        >
                            <p class="box" id="box">机构基本信息</p>
                        </div>
                    </div>
                    <el-form
                        style="background: #01117b"
                        label-position="right"
                        label-width="120px"
                        ref="orgsData"
                        :model="info"
                        class=""
                        v-show="step == 0"
                    >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="机构名称：">
                                    <el-input
                                        v-model="info.name"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="机构地址：">
                                    <el-input
                                        v-model="info.address"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建时间：">
                                    <el-input
                                        v-model="info.build"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系人：">
                                    <el-input
                                        v-model="info.person"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="联系电话：">
                                    <el-input
                                        v-model="info.phone"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="建筑面积：">
                                    <el-input
                                        v-model="info.area"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="性质：">
                                    <el-input
                                        v-model="info.nature"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="房屋性质：">
                                    <el-input
                                        v-model="info.houserNature"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <!-- 老人信息展示框 -->
            <div class="older-info">
                <el-dialog
                    title="信息"
                    :visible.sync="olderInfoVisible"
                    width="35%"
                    style="margin-top: 15vh"
                >
                    <div>
                        <el-form
                            label-position="right"
                            label-width="100px"
                            ref="objList"
                            :model="objList"
                            class="content-info"
                        >
                            <el-form-item
                                class="content-info-item"
                                label="姓名："
                                prop="name"
                            >
                                <el-input
                                    :value="objList.name"
                                    disabled
                                ></el-input>
                            </el-form-item>

                            <el-form-item
                                class="content-info-item"
                                label="年龄："
                                prop="age"
                            >
                                <el-input
                                    :value="objList.age"
                                    disabled
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                class="content-info-item"
                                label="性别："
                                prop="sex"
                            >
                                <!-- <el-input :value="objList.sex" disabled></el-input> -->
                                <el-select
                                    v-model="objList.sex"
                                    disabled
                                    style="width: 100%"
                                >
                                    <el-option value="1" label="男"></el-option>
                                    <el-option value="2" label="女"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                class="content-info-item"
                                label="身体状况："
                                prop="conditional"
                            >
                                <el-input
                                    :value="objList.conditional"
                                    disabled
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                class="content-info-item"
                                label="失能等级："
                                prop="assessment"
                            >
                                <el-select
                                    v-model="objList.assessment"
                                    disabled
                                    style="width: 100%"
                                >
                                    <el-option
                                        :value="1"
                                        label="自理"
                                    ></el-option>
                                    <el-option
                                        :value="2"
                                        label="半自理"
                                    ></el-option>
                                    <el-option
                                        :value="3"
                                        label="失能"
                                    ></el-option>
                                    <el-option
                                        :value="4"
                                        label="半失能"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                class="content-info-item"
                                label="所属机构："
                                prop="mechanismCareName"
                            >
                                <el-input
                                    :value="objList.mechanismCareName"
                                    disabled
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-dialog>
            </div>
            <!-- 巡检信息展示框 -->
            <div class="older-info">
                <el-dialog
                    title="巡检信息"
                    :visible.sync="xunInfoVisible"
                    width="30%"
                    style="margin-top: 35vh"
                >
                    <div>
                        <el-form
                            label-position="center"
                            label-width="100px"
                            ref="xunList"
                            :model="xunList"
                            class=""
                        >
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item
                                        label="巡检名称:"
                                        prop="insName"
                                    >
                                        <el-input
                                            style="width: 96%"
                                            v-model="xunList.insName"
                                            placeholder="请输入巡检名称"
                                            disabled
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="设置时限:">
                                        <el-date-picker
                                            v-model="xunList.startTime"
                                            type="datetime"
                                            placeholder="开始时间"
                                            class="searchTjContentDivInput"
                                            clearable
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            disabled
                                        >
                                        </el-date-picker>
                                        <span
                                            class="searchTjContentDivSpan"
                                            style="padding: 0 20px"
                                            >至</span
                                        >
                                        <el-date-picker
                                            v-model="xunList.endTime"
                                            type="datetime"
                                            placeholder="结束时间"
                                            class="searchTjContentDivInput"
                                            clearable
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            disabled
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item
                                        label="巡检机构:"
                                        prop="insOrgName"
                                    >
                                        <el-input
                                            style="width: 96%"
                                            v-model="xunList.insOrgName"
                                            disabled
                                            placeholder="请输入巡检名称"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="巡检人员:"
                                        prop="insPersonName"
                                    >
                                        <el-input
                                            style="width: 96%"
                                            v-model="xunList.insPersonName"
                                            disabled
                                            placeholder="请输入巡检人员"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        return {
            map: null,
            marker: null,
            markers: [],
            recMarker: null,

            stationList: [
                {
                    id: "0",
                    name: "华阳镇敬老院",
                    address: "绩溪县华阳镇龙川大道柏枝湾",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "程华光",
                    phone: "13856385158",
                    longitude: "118.594024",
                    latitude: "30.066273",
                    build: "1994",
                    area: "占地1100m²，建筑791m²",
                },
                {
                    id: "1",
                    name: "临溪镇敬老院",
                    address: "绩溪县临溪镇临溪村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "胡树发",
                    phone: "13635633584",
                    longitude: "118.549442",
                    latitude: "29.994102",
                    build: "2012",
                    area: "占地1200m²，建筑1000m²",
                },
                {
                    id: "2",
                    name: "长安镇敬老院",
                    address: "绩溪县长安镇镇头村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "周顺和",
                    phone: "13329296783",
                    longitude: "118.528335",
                    latitude: "30.154409",
                    build: "1992",
                    area: "占地2500m²，建筑1868m²",
                },
                {
                    id: "3",
                    name: "上庄镇敬老院",
                    address: "绩溪县上庄镇上庄村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "汪卫国",
                    phone: "13866965240",
                    longitude: "118.444977",
                    latitude: "30.128291",
                    build: "2011",
                    area: "占地3400m²，建筑1600m²",
                },
                {
                    id: "4",
                    name: "扬溪镇敬老院",
                    address: "绩溪县扬溪镇大石门村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "周玥莉",
                    phone: "15105638033",
                    longitude: "118.703705",
                    latitude: "30.161707",
                    build: "2012",
                    area: "占地1050m²，建筑975m²",
                },
                {
                    id: "5",
                    name: "板桥头乡敬老院",
                    address: "绩溪县板桥头乡尚田村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "汪卫忠",
                    phone: "13966223597",
                    longitude: "118.586983",
                    latitude: "30.223503",
                    build: "2008",
                    area: "占地2050m²，建筑1010m²",
                },
                {
                    id: "6",
                    name: "金沙镇敬老院",
                    address: "绩溪县金沙镇金沙村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "周金虎",
                    phone: "13965401731",
                    longitude: "118.746959",
                    latitude: "30.269039",
                    build: "2010",
                    area: "占地1700m²，建筑628m²",
                },
                {
                    id: "7",
                    name: "伏岭镇敬老院",
                    address: "绩溪县伏岭镇水村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "程训建",
                    phone: "13365635949",
                    longitude: "118.722549",
                    latitude: "30.105288",
                    build: "2012",
                    area: "占地5860m²，建筑2622m²",
                },
                {
                    id: "8",
                    name: "家朋乡敬老院",
                    address: "绩溪县家朋乡家朋村和阳村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "汪六园",
                    phone: "13805622623",
                    longitude: "118.857315",
                    latitude: "30.275377",
                    build: "2012",
                    area: "占地854m²，建筑1252.2m²",
                },
                {
                    id: "9",
                    name: "荆州乡敬老院",
                    address: "绩溪县荆州乡下胡家村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "胡金水",
                    phone: "17356333996",
                    longitude: "118.782104",
                    latitude: "30.204521",
                    build: "2012",
                    area: "占地350m²，建筑700m²",
                },
                {
                    id: "10",
                    name: "龙川中心敬老院",
                    address: "绩溪县瀛洲镇瀛洲村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "章玉秋",
                    phone: "17756934637",
                    longitude: "118.650642",
                    latitude: "30.061712",
                    build: "2010",
                    area: "占地6670m²，建筑3000m²",
                },
            ],
            info: {
                id: "",
                name: "",
                address: "",
                nature: "",
                houserNature: "",
                person: "",
                phone: "",
                build: "",
                area: "",
            },
            totalOccupancyRatio: "",
            eldlyData: [], //列表数据
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            step: 0,
            tableData: [
                {
                    date: "001",
                    name: "王小虎",
                    address: "上海市",
                },
            ],
            mechanism: false,
            olderInfoVisible: false,
            objList: {},
            xunList: {},
            xunInfoVisible: false,
            map: null,
            marker: null,
            onFullScreen: false,
            recMarker: null,
            scrollHeight: 620,
            communityList2: [],
            communityList: [],
            orgsData: [],
            markers: [],
            tableList: [],
            insList: [
                {
                    id: "149",
                    insName: "安全巡检",
                    startTime: "8/30/2021 16:54:52",
                    endTime: "9/30/2021 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "消防巡检",
                    startTime: "8/30/2021 00:00:00",
                    endTime: "9/30/2021 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "街道巡检",
                    startTime: "8/30/2021 16:55:54",
                    endTime: "9/30/2021 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "卫生巡检",
                    startTime: "8/30/2021 00:00:00",
                    endTime: "9/30/2021 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "门锁安全巡检",
                    startTime: "8/30/2021 16:54:52",
                    endTime: "9/30/2021 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "卫生巡检",
                    startTime: "8/30/2021 00:00:00",
                    endTime: "9/30/2021 00:00:00",
                    insPersonName: "wangq",
                },
            ],
            communityId: "",
            oldInfo: {},
            infoWindow: {},
            BedNum: [], //床位数
            BedName: [], //床位数对应名称
            Occupancy: [], //入住比例
            Infors: [], //
            Ability: [], //入住老人能力评估
            Levels: [], //机构等级
            Statistics: [], //机构统计
            Care: [], //医养结合覆盖率
            CareStatistics: [], //
            occupancyElderlyNum0: 35,
            occupancyElderlyNum1: 21,
            occupancyElderlyNum2: 59,
            occupancyElderlyNum3: 60,
            occupancyElderlyNum4: 69,
            occupancyElderlyNum5: 36,
            occupancyElderlyNum6: 45,
            occupancyElderlyNum7: 43,
            occupancyElderlyNum8: 33,
            occupancyElderlyNum9: 39,
            occupancyElderlyNum10: 45,
            mechanism0: "",
            mechanism1: "",
            mechanism2: "",
            mechanism3: "",
            sumMechanism: 0,
            sumBed: 0,
        }
    },
    computed: {
        defaultOption() {
            return {
                step: 0.5, // 数值越大速度滚动越快
                limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            }
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.loadMap().then(() => {
                this.getDistrict()
                this.showditu()
                this.bathPoint()
            })
        })
        this.getComList() //定位
        this.getBed() //床位数
        this.getOld()
        this.getCombination()
        this.geteldList()

        // 数据
        // console.log(this.$refs.ability);
        this.getelderlyData() //获取所有数据
        // this.getPolygon();

        // this.getData();
        // this.getinsData()
        const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    methods: {
        // 批量打点
        bathPoint() {
            const self = this
            let f1 = require("./assets/big/jigou44.png")
            this.stationList.forEach((item, i) => {
                let icon = f1
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: new AMap.Icon({
                        image: icon,
                        size: new AMap.Size(52, 52), //图标大小
                        imageSize: new AMap.Size(30, 30),
                    }),
                    extData: {
                        id: item.id,
                        name: item.name,
                        address: item.address,
                        nature: item.nature,
                        houserNature: item.houserNature,
                        person: item.person,
                        phone: item.phone,
                        build: item.build,
                        area: item.area,
                    },
                })
                self.markers.push(marker)

                marker.on("click", self.maskModel)
            })
            self.map.add(self.markers)
        },
        maskModel(e) {
            let data = e.target.w.extData
            this.info = {
                name: data.name,
                address: data.address,
                nature: data.nature,
                houserNature: data.houserNature,
                person: data.person,
                phone: data.phone,
                build: data.build,
                area: data.area,
            }
            this.mechanism = true
            // console.log(e.target.w.extData, "点击事件")
        },
        drawArea() {
            for (let i = 0; i < this.areaList.length; i++) {
                // console.log(this.areaList,'2222')
                this.getArea(this.areaList[i].adcode, this.areaList[i].color)
            }
        },
        getArea(name, color) {
            // console.log(name, color)
            const self = this
            var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
            }
            let district = new AMap.DistrictSearch(opts)

            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker()
            district.search(name, (status, result) => {
                if (status == "complete") {
                    let bounds = result.districtList[0].boundaries
                    self.polygons = []
                    for (var i = 0, l = bounds.length; i < l; i++) {
                        self.polygon = new AMap.Polygon({
                            map: self.map,
                            strokeWeight: 1,
                            strokeColor: "#007CDB",
                            fillColor: color,
                            fillOpacity: 0.06,
                            path: bounds[i],
                        })
                        self.polygons.push(self.polygon)
                    }
                    // self.map.setFitView() //地图自适应
                }
            })
        },
        getDistrict(name = "341824", params = null) {
            let self = this
            // return new Promise((resolve, reject) => {
            var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
            }
            let district = new AMap.DistrictSearch(opts)

            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }

            self.marker = new AMap.Marker()
            district.search(name, (status, result) => {
                if (status == "complete") {
                    let areaList = []
                    result.districtList[0].districtList.forEach((item) => {
                        // console.log(item, "下次code")
                        areaList.push({
                            adcode: item.adcode,
                            name: item.name,
                        })
                    })
                    areaList[0].color = "#24609C"
                    areaList[1].color = "#467399"
                    areaList[2].color = "#0C2FA0"
                    areaList[3].color = "#3769A6"
                    areaList[4].color = "#22598D"
                    areaList[5].color = "#326A9D"
                    areaList[6].color = "#0C2FA0"
                    areaList[7].color = "#2568A2"
                    areaList[8].color = "#134CA2"
                    areaList[9].color = "#183B77"
                    areaList[10].color = "#183B70"
                    areaList[11].color = "#183B70"

                    self.areaList = areaList
                    self.drawArea()
                }
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 10,
                    center: ["118.87", "30.07"],
                })
                resolve()
            })
        },
        //老人列表数据
        async geteldList(id) {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
            }
            // findListVisualization
            this.$http
                .request({
                    // url: "/ypt/admin/mechanismCarePeople/info/findList",
                    url: "/ypt/admin/jixi/customer/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.eldlyData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.eldlyData = res.content.list
                        this.tableList = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },

        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.geteldList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.geteldList()
        },
        // 按钮切换
        stepTap(nums) {
            this.step = nums

            const box = document.getElementById("box")
            const box2 = document.getElementById("box2")
            if (nums == 0) {
                box.style.fontSize = "25px"
                box2.style.fontSize = "20px"
            }
            if (nums == 3) {
                box.style.fontSize = "20px"
                box2.style.fontSize = "25px"
            }
        },
        async getComList() {
            // let params = {
            //       pageNo: 1,
            //       pageSize: 10,
            //   }
            //   this.$http
            //       .request({
            //           // url: "/ypt/admin/mechanismCare/info/findList",
            //           url: "/ypt/admin/mechanismCare/info/findListVisualization",
            //           method: "POST",
            //           data: params,
            //       })
            //       .then((res) => {
            //           if (res.code == 200) {
            //               if (res.content == null || res.content == "null") {
            //                   this.communityList = []
            //                   return
            //               }
            //               this.$set(this,'communityList',res.content.list)
            //               // this.communityList = res.content.list
            //               // this.markets();
            //           }
            //       })
        },
        //社区图标
        async showditu() {
            this.map.remove(this.markers)
            this.markers = []
            this.renderMapMarker(this.communityList)
        },
        renderMapMarker(data) {
            let self = this
            console.log(data, "QWeqqwe")
            if (data.length) {
                var endIcon = new AMap.Icon({
                    size: new AMap.Size(49, 56),
                    image: require("./assets/big/f1.png"),
                    imageSize: new AMap.Size(38, 42),
                })
                console.log(data.longitude, data.latitude)
                data.forEach((item) => {
                    let marker = new AMap.Marker({
                        position: [
                            item.longitude || item.addressLng,
                            item.latitude || item.addressLat,
                        ],
                        icon: endIcon,
                    })
                    self.markers.push(marker)
                    marker.on("mouseover", (e) => {})
                    marker.on("click", (e) => {})
                })
            }
            self.map.add(self.markers)
            self.map.setFitView(self.markers)
        },
        markets() {
            //  this.getPolygon()
            this.map = new AMap.Map("party-map", {
                zoom: 13,
                zooms: [3, 20],
                center: [118.638, 32.049],
                showLabel: false,
                mapStyle: "amap://styles/darkblue",
            })
            // console.log(this.communityList,'this.communityList')
            let m1 = require("./assets/big/jigou11.png")
            let m2 = require("./assets/big/jigou22.png")
            let m3 = require("./assets/big/jigou33.png")
            let m4 = require("./assets/big/jigou44.png")
            // for (var i = 0; i < this.communityList.length; i++) {
            //   var icon2 = ""
            //   if (i == 1) {
            //     icon2 = m1;
            //   } else if (i ==2 ) {
            //     icon2 = m2;
            //   } else if (i == 3) {
            //     icon2 = m3;
            //   } else if (i == 4) {
            //     icon2 = m4;
            //   }
            // }
            this.communityList.forEach((item, i) => {
                var icon2 = ""
                if (i == 0) {
                    icon2 = m1
                } else if (i == 1) {
                    icon2 = m2
                } else if (i == 2) {
                    icon2 = m3
                } else if (i == 3) {
                    icon2 = m4
                }
                if (item.longitude && item.latitude) {
                    var marker = new AMap.Marker({
                        position: [item.longitude, item.latitude],
                        icon: new AMap.Icon({
                            image: icon2,
                            size: new AMap.Size(52, 52), //图标大小
                            imageSize: new AMap.Size(30, 30),
                        }),

                        map: this.map,
                    })
                    this.markers.push(marker)
                    marker.setLabel({
                        offset: new AMap.Pixel(12, 12),
                        content: item.organizationName,
                        direction: "center",
                    })
                    marker.on("click", (e) => {
                        this.mechanism = true
                        console.log(item)
                        this.getById(item.id)
                        this.getData(item.id)
                        this.geteldList(item.id)
                        this.getelderlyData(item.id) //根据不同的机构变换不同的老人数据
                    })
                }
            })
        },
        getById(id) {
            let self = this
            self.$http
                .request({
                    url: "/ypt/admin/mechanismCare/info/get",
                    method: "POST",
                    data: {
                        id: id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        self.orgsData = res.content
                    }
                })
        },
        // 关闭弹窗
        close() {
            this.mechanism = false
        },
        // 点击显示老人信息
        showInfo(e) {
            let item = JSON.parse(e.target.dataset.obj)
            this.objList = item
            console.log(this.objList, item)
            // this.olderInfoVisible = true;
        },
        showXunInfo(e) {
            let item = JSON.parse(e.target.dataset.obj)
            this.xunList = item
            console.log(this.xunList, item)
            this.xunInfoVisible = true
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        markerClick(e) {
            // alert(11111111)
            this.infoWindow.setContent(e.target.content)
            this.infoWindow.open(this.map, e.target.getPosition())
            let cname = e.target.name //机构或者社区名称
            // this.getnewData(cname);
            this.mechanism = true
            this.getAbility()
            this.getBody()
            this.getCost()
            console.log(e)
        },

        async getnewData(n) {
            // findListVisualization
            var res = await request({
                url: "/ypt/admin/mechanismCarePeople/info/findListVisualization",
                method: "POST",
                data: {
                    communityId: this.communityId,
                    pageNo: 1,
                    pageSize: 10,
                },
            })
            if (res.code == 200) {
                this.tableList = res.content.elderlyInfors.filter((item) => {
                    return item.mechanism == n //显示对应社区滚动列表
                })
            }
        },

        // 入住老人数据
        async getData(CareId) {
            // findListVisualization
            var res = await request({
                url: "/ypt/admin/mechanismCarePeople/info/findListVisualization",
                method: "POST",
                data: {
                    mechanismCareId: CareId,
                    pageNo: 1,
                    pageSize: 10,
                },
            })
            if (res.code == 200) {
                // this.oldInfo = res.content;
                this.tableList = res.content.list
            }
        },
        // 巡检数据
        async getinsData() {
            // // findListVisualization
            // var res = await request({
            //   url: "/ypt/admin/securityIns/info/findListVisualization",
            //   method: "POST",
            //   data: {
            //     // communityId: this.communityId,
            //      pageNo:1,
            //      pageSize:10
            //   },
            // });
            // if (res.code == 200) {
            // this.oldInfo = res.content;
            //   this.insList = res.content.list;
            // }
        },
        async getelderlyData(CareId) {
            this.getOld() //机构等级覆盖率
            this.getCombination()
            this.getLodLiveEcharts() //入住老人能力评估
            this.getNursing() //评估能力比例
            if (CareId == undefined) {
                //首次初始化执行
                this.percentShow("num", "wave-mask", this.occupancyElderlyNum0)
                this.percentShow(
                    "num1",
                    "wave-mask1",
                    this.occupancyElderlyNum1
                )
                this.percentShow(
                    "num2",
                    "wave-mask2",
                    this.occupancyElderlyNum2
                )
                this.percentShow(
                    "num3",
                    "wave-mask3",
                    this.occupancyElderlyNum3
                )
                this.percentShow(
                    "num4",
                    "wave-mask4",
                    this.occupancyElderlyNum4
                )
                this.percentShow(
                    "num5",
                    "wave-mask5",
                    this.occupancyElderlyNum5
                )
                this.percentShow(
                    "num6",
                    "wave-mask6",
                    this.occupancyElderlyNum6
                )
                this.percentShow(
                    "num7",
                    "wave-mask7",
                    this.occupancyElderlyNum7
                )
                this.percentShow(
                    "num8",
                    "wave-mask8",
                    this.occupancyElderlyNum8
                )
                this.percentShow(
                    "num9",
                    "wave-mask9",
                    this.occupancyElderlyNum9
                )
                this.percentShow(
                    "num10",
                    "wave-mask10",
                    this.occupancyElderlyNum10
                )
            }
            this.getNursing()
        },
        // 入住能力评估比例
        getNursing() {
            const myChart = this.$echarts.init(document.getElementById("huli"))
            var option
            option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}:  ({d}%)",
                },
                color: ["#c63c26", "#65AC3A", "#36cfc9", "#AC03E2"],
                series: [
                    {
                        name: "入住能力评估",
                        type: "pie",
                        radius: ["30%", "50%"],
                        center: ["50%", "50%"],
                        roseType: "area",
                        itemStyle: {
                            borderRadius: 5,
                        },
                        data: [
                            { name: "自理", value: 459 },
                            { name: "半自理", value: 210 },
                            { name: "失能", value: 30 },
                            { name: "半失能", value: 44 },
                        ],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :({d}%)",
                                },
                                labelLine: { show: true },
                            },
                        },

                        label: {
                            formatter: function (params) {
                                var tempStr = params.data.name.substring(0, 3)
                                var tempStr1 = params.data.name.substring(
                                    3,
                                    params.data.name.length
                                )
                                var tempStr2 = tempStr + "\n" + tempStr1

                                return tempStr2
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        //百分比
        percentShow(numl, wave, nums) {
            let timerRef = null
            let loading = 0
            let numEle = document.getElementById(numl)
            let maskEle = document.getElementById(wave)

            timerRef = setInterval(() => {
                const num = loading + 0.49
                if (num >= nums) {
                    loading = nums
                    clearInterval(timerRef)
                } else {
                    loading = num
                }
                numEle.innerHTML =
                    loading >= 100 ? 100 : loading.toFixed(2) + "%" // 显示两位小数
                maskEle.style.top = 100 - loading + "%"
            }, 150)
        },
        // 床位数
        getBed() {
            //  let xData=[],
            //      yData=[]
            //  this.BedNum.forEach(item=>{
            //        yData.push(item.bedNum)
            //        xData.push(item.organizationName)
            //   })
            const myChart = this.$echarts.init(document.getElementById("beds"))
            var option
            option = {
                grid: {
                    top: "10%",
                    left: "3%",
                    right: "4%",
                    bottom: "7%",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                title: {
                    subtext: "床位数", //副标题
                    left: "15",
                    subtextStyle: {
                        //对应样式
                        color: "#00D2FF",
                        fontSize: 16,
                    },
                },

                color: [
                    "#7FD42D",
                    "#F21B62",
                    "#FFB026",
                    "#D800FF",
                    "#7FD42D",
                    "#F21B62",
                    "#FFB026",
                    "#D800FF",
                    "#7FD42D",
                    "#F21B62",
                    "#FFB026",
                    "#D800FF",
                ],
                xAxis: {
                    type: "category",
                    data: [
                        "华阳镇",
                        "临溪镇",
                        "长安镇",
                        "上庄镇",
                        "扬溪镇",
                        "板桥头乡",
                        "金沙镇",
                        "伏岭镇",
                        "家朋乡",
                        "荆州乡",
                        "龙川中心",
                    ],
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                    // data: xData,
                    // data: xData,
                    // axisLabel: {
                    //     interval: 0,
                    //     rotate: 90,
                    // },
                    // axisLabel: {
                    //   // 坐标轴刻度标签换行处理
                    //   formatter: function (params) {
                    //     var newParamsName = ""; // 最终拼接成的字符串
                    //     var paramsNameNumber = params.length; // 实际标签的个数
                    //     var provideNumber = 4; // 每行能显示的字的个数
                    //     var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                    //     /**
                    //      * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                    //      */
                    //     // 条件等同于rowNumber>1
                    //     if (paramsNameNumber > provideNumber) {
                    //       /** 循环每一行,p表示行 */
                    //       for (var p = 0; p < rowNumber; p++) {
                    //         var tempStr = ""; // 表示每一次截取的字符串
                    //         var start = p * provideNumber; // 开始截取的位置
                    //         var end = start + provideNumber; // 结束截取的位置
                    //         // 此处特殊处理最后一行的索引值
                    //         if (p == rowNumber - 1) {
                    //           // 最后一次不换行
                    //           tempStr = params.substring(start, paramsNameNumber);
                    //         } else {
                    //           // 每一次拼接字符串并换行
                    //           tempStr = params.substring(start, end) + "\n";
                    //         }
                    //         newParamsName += tempStr; // 最终拼成的字符串
                    //       }
                    //     } else {
                    //       // 将旧标签的值赋给新标签
                    //       newParamsName = params;
                    //     }
                    //     //将最终的字符串返回
                    //     return newParamsName;
                    //   },
                    // },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                series: [
                    {
                        // data: yData,
                        data: [23, 33, 77, 86, 36, 64, 51, 88, 75, 33, 80],
                        itemStyle: {
                            normal: {
                                //这里是重点
                                color: function (params) {
                                    //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                    var colorList = [
                                        "#7FD42D",
                                        "#F21B62",
                                        "#FFB026",
                                        "#D800FF",
                                        "#7FD42D",
                                        "#F21B62",
                                        "#FFB026",
                                        "#D800FF",
                                        "#7FD42D",
                                        "#F21B62",
                                        "#FFB026",
                                        "#D800FF",
                                    ]
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        type: "bar",
                        showBackground: true,
                        backgroundStyle: {
                            color: "rgba(180, 180, 180, 0.2)",
                        },
                        barGap: "0",
                        label: {
                            normal: {
                                show: true,
                                formatter: "{c}",
                                align: "center",
                                position: "top",
                                distance: 10,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 入住老人能力评估
        getLodLiveEcharts() {
            this.chartFour = this.$echarts.init(this.$refs.lodLiveEcharts)
            // 编写echart参数
            let option = {
                grid: {
                    left: "20%",
                    right: "10%",
                    bottom: "22%",
                    top: "10%",
                    // containLabel: true,
                },
                xAxis: {
                    type: "category",
                    // boundaryGap: false,
                    data: ["自理", "半自理", "半失能", "失能"],
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    // boundaryGap: [0, "50%"],

                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                series: [
                    {
                        name: "",
                        type: "bar",
                        barWidth: 33,
                        radius: ["60%", "50%"],
                        center: ["50%", "40%"],
                        data: [459, 210, 44, 30],
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList2 = [
                                        "#c63c26",
                                        "#65AC3A",
                                        "#36cfc9",
                                        "#AC03E2",
                                    ]
                                    return colorList2[params.dataIndex]
                                },
                            },
                        },
                    },
                ],
            }
            // 设置图表的参数
            this.chartFour.setOption(option)
        },
        // 能力评估
        getAbility() {
            const myChart = this.$echarts.init(this.$refs.ability)
            var option
            option = {
                // title: {
                //   subtext: "机构评级覆盖率", //副标题
                //   left: "15",
                //   subtextStyle: {
                //     //对应样式
                //     color: "#00D2FF",
                //     fontSize: 9,
                //   },
                // },
                tooltip: {
                    trigger: "item",
                },
                // legend:{
                //   show:true,
                //   left:"60%",
                //   height:"80%",
                //   orient:"vertical",
                //   align:"left",
                //   top:'20%',
                //   textStyle:{
                //     color:'#fff'
                //   }
                // },
                color: ["#0F5BF5", "#7FD42D", "#F21B62"],
                series: [
                    {
                        name: "能力评估",
                        type: "pie",
                        radius: "50%",
                        // radius: ['30%','50%'],
                        data: [
                            { value: 250, name: "市三级" },
                            { value: 250, name: "市一级" },
                            { value: 500, name: "其他" },
                        ],
                        label: {
                            show: true,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 身体状况
        getBody() {
            const myChart = this.$echarts.init(this.$refs.body)
            var option
            var yData = []
            var total = 0
            this.oldInfo.medicalCareStatistics.forEach((item) => {
                total += item.countMedical
                yData.push({ value: item.countMedical, name: item.medical })
            })
            for (let i = 0; i < yData.length; i++) {
                yData[i].name =
                    yData[i].name +
                    ((yData[i].value / total) * 100).toFixed(2) +
                    "%"
            }
            option = {
                // title: {
                //   subtext: "养老机构医养结合覆盖率", //副标题
                //   left: "15",
                //   subtextStyle: {
                //     //对应样式
                //     color: "#00D2FF",
                //     fontSize: 9,
                //   },
                // },
                // tooltip: {
                //     trigger: "item",
                // },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}:  ({d}%)",
                },
                color: ["#FFB026", "#D800FF"],
                series: [
                    {
                        name: "身体状况",
                        type: "pie",
                        radius: ["30%", "50%"],
                        // data: yData,
                        data: [
                            { value: 250, name: "医务室" },
                            { value: 250, name: "护理站" },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 费用
        getCost() {
            const myChart = this.$echarts.init(this.$refs.cost)
            var option
            var yData = []
            var total = 0
            this.oldInfo.medicalCareStatistics.forEach((item) => {
                total += item.countMedical
                yData.push({ value: item.countMedical, name: item.medical })
            })
            for (let i = 0; i < yData.length; i++) {
                yData[i].name =
                    yData[i].name +
                    ((yData[i].value / total) * 100).toFixed(2) +
                    "%"
            }
            option = {
                color: ["#FFB026", "#D800FF"],
                series: [
                    {
                        name: "养老机构医养结合覆盖率",
                        type: "pie",
                        radius: ["30%", "50%"],
                        // data: yData,
                        data: [
                            { value: 250, name: "医务室：50%" },
                            { value: 250, name: "护理站：50%" },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 机构评级覆盖率
        getOld() {
            const myChart = this.$echarts.init(
                document.getElementById("mechanism")
            )
            var option
            option = {
                title: {
                    subtext: "机构评级覆盖率", //副标题
                    left: "15",
                    subtextStyle: {
                        //对应样式
                        color: "#00D2FF",
                        fontSize: 10,
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    right: "3%",
                    top: "8%",
                    textStyle: {
                        //图例文字的样式
                        color: "#fff",
                        fontSize: 16,
                    },
                },
                color: ["#0F5BF5", "#7FD42D", "#F21B62"],
                series: [
                    {
                        name: "机构评级覆盖率",
                        type: "pie",
                        // radius: "48%",
                        radius: ["35%", "50%"],
                        center: ["50%", "60%"],
                        data: [
                            { value: 12, name: "AAA" },
                            { value: 5, name: "AA" },
                            { value: 1, name: "A" },
                        ],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :({d}%)",
                                },
                                labelLine: { show: true },
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 医养结合
        getCombination() {
            const myChart = this.$echarts.init(
                document.getElementById("combination")
            )
            var option
            option = {
                title: {
                    subtext: "养老机构医养结合覆盖率", //副标题
                    left: "15",
                    subtextStyle: {
                        //对应样式
                        color: "#fff",
                        fontSize: 16,
                    },
                },
                legend: {
                    top: "5%",
                    right: "8%",
                    textStyle: {
                        //图例文字的样式
                        color: "#fff",
                        fontSize: 16,
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                color: ["#FFB026", "#D800FF"],
                series: [
                    {
                        name: "养老机构医养结合覆盖率",
                        type: "pie",
                        radius: ["30%", "50%"],
                        center: ["50%", "50%"],
                        // data: yData,
                        data: [{ value: 12, name: "是" }],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :({d}%)",
                                },
                                labelLine: { show: true },
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 获取社区区域图
        async getPolygon() {
            //机构管理
            // /rbac/admin/org/info/OrgTreelist
            // OrgTreelistVisualization
            const res = await this.$post(
                "/rbac/admin/org/info/OrgTreelistVisualization",
                {}
            )
            this.communityList2 = res.content[0].children
            this.markets()
            // this.showditu()

            res.content[0].children.forEach((item) => {
                let polygonArr = []

                if (item.pointPosition) {
                    item.pointPosition.split(",").forEach((e) => {
                        polygonArr.push(e.split(":"))
                    })
                    const polygon = new AMap.Polygon({
                        map: this.map,
                        path: polygonArr, //设置多边形边界路径
                        strokeColor: "#007CDB", //线颜色
                        strokeOpacity: 0.5, //线透明度
                        strokeWeight: 1, //线宽
                        fillColor: "#2191E6", //填充色
                        fillOpacity: 0.3, //填充透明度
                        extData: {
                            name: item.label,
                        },
                    })
                    polygon.id = item.orgId
                    polygon.address = item.label
                    //点击事件.
                    // polygon.projectId=polygonArr[item].id;
                    polygon.on("click", async (e) => {
                        // this.map.zoomIn();
                    })
                    //变色
                    polygon.on("mouseover", function () {
                        this.setOptions({
                            strokeOpacity: 1, //线透明度
                            strokeWeight: 2, //线宽
                            fillOpacity: 1, //填充透明度
                        })
                    })
                    polygon.on("mouseout", function () {
                        this.setOptions({
                            strokeOpacity: 0.5, //线透明度
                            strokeWeight: 1, //线宽
                            fillOpacity: 0.5, //填充透明度
                        })
                    })
                }
            })
        },
        // // 获取网格区域图
        // async getPolygon() {
        //   const res = await this.$post(
        //     "/ypt/admin/standardAddress/info/StandardAddressTree",
        //     { jiedaoId: "3201111" }
        //   );

        //   // console.log(res, "数据");
        //   res.content.forEach((item) => {
        //     let polygonArr = [];
        //     if (item.areaDivision) {
        //       item.areaDivision.split(",").forEach((e) => {
        //         polygonArr.push(e.split(":"));
        //       });
        //       console.log("坐标系", item.color);
        //       const polygon = new AMap.Polygon({
        //         map: this.map,
        //         path: polygonArr, //设置多边形边界路径
        //         strokeColor: "#1135D8", //线颜色
        //         strokeOpacity: 0.5, //线透明度
        //         strokeWeight: 1, //线宽
        //         fillColor: item.color, //填充色
        //         fillOpacity: 0.5, //填充透明度
        //         extData: {
        //           name: item.address,
        //         },
        //       });
        //       //点击事件
        //       polygon.on("click", function (e) {
        //         // that.$emit("setOrgId", item.id);
        //         // alert(111111111)
        //       });
        //       //变色
        //       polygon.on("mouseover", function () {
        //         this.setOptions({
        //           strokeOpacity: 1, //线透明度
        //           strokeWeight: 3, //线宽
        //           fillOpacity: 1, //填充透明度
        //         });
        //       });
        //       polygon.on("mouseout", function () {
        //         this.setOptions({
        //           strokeOpacity: 0.5, //线透明度
        //           strokeWeight: 1.5, //线宽
        //           fillOpacity: 0.5, //填充透明度
        //         });
        //       });
        //     }
        //   });
        // },
    },
    destroyed() {
        this.map && this.map.destroy()
    },
}
</script>

<style lang="less" scoped>
#container {
    position: absolute;
    left: 0;
    right: 0;
    top: 100px;
    bottom: 0;
    z-index: 1;
}
.box {
    color: #c4e2ff;
}
.box:hover {
    cursor: pointer;
    color: #fff;
}
.tableBox /deep/ .el-table--fit {
    // padding: 20px;
    // background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table,
.el-table__expanded-cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}

.tableBox /deep/ .el-table tr .is-center {
    background-color: #01117b !important;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}

/deep/.amap-marker-label {
    border: none;
    font-size: 12px;
    color: #fff;
    margin-top: 5px;
    background: none;
    margin-left: -20px;
}
#ability {
    height: 100px;
    width: 200px;
}
#body {
    height: 100px;
    width: 200px;
}
#cost {
    height: 100px;
    width: 200px;
}
.mechanism_info {
    padding: 0;
    position: absolute;
    top: 20%;
    left: 20%;
    width: 60%;
    z-index: 999;
    background: rgba(10, 88, 160, 0.8);
    .mechanismName {
        height: 40px;
        background-color: #17378f;
        color: #fff;
        text-align: center;
        font-size: 20px;
        line-height: 40px;
    }
    .x {
        position: absolute;
        top: 5px;
        right: 13px;
        font-size: 22px;
        color: #fff;
        cursor: pointer;
    }
    .content1 {
        margin: 20px 20px 0;
    }
}

.content-info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
}

.content-info-item {
    width: 45%;
}
.main {
    background: url("./assets/big/data_bg.png") repeat;
    // overflow-x: hidden;
    width: 100%;
    .realTop {
        position: absolute;
        top: 0px;
        z-index: 2;
        background: url("./assets/big/oldTitle3.png");
        background-size: cover;
        margin: 0 auto;
        height: 90px;
        width: 100%;
    }
}
.oldBox {
    border: 1px solid rgba(34, 236, 255, 1);
    background: #01117b;
    margin-top: 28px;
    position: relative;
    min-height: 35px;
    .leftTitle {
        position: absolute;
        width: 100%;
        height: 35px;
        background: url("./assets/big/titleLeft.png") no-repeat center;
        text-align: center;
        font-size: 20px;
        line-height: 35px;
        color: #22f7ff;
        top: -17px;
        z-index: 200;
    }
}
.superLeft {
    position: absolute;
    top: 100px;
    left: 20px;
    width: 354px;
    bottom: 0px;
    z-index: 2;
    .superBox {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .chartTitle1 {
        padding-top: 15px;
    }
    .borderLine {
        background: linear-gradient(
            to right,
            rgba(41, 104, 232, 0),
            rgba(41, 104, 232, 1),
            rgba(41, 104, 232, 0)
        );
        height: 3px;
    }
    #beds {
        width: 100%;
        height: 36vh;
        margin-top: 20px;
    }
    #mechanism {
        margin-top: 10px;
        width: 100%;
        height: 24vh;
    }
    #combination {
        margin-top: 10px;
        width: 100%;
        height: 24vh;
    }
    .tip {
        color: #fff;
        text-align: center;
        font-size: 12px;
    }
    .tipUl {
        padding: 10px 15px;
        color: #fff;
        font-size: 13px;
        line-height: 22px;
        li {
            display: flex;
            .name {
                flex: 1;
            }
        }
    }
}

.superRight {
    position: absolute;
    top: 100px;
    right: 20px;
    width: 795px;
    bottom: 0;
    z-index: 2;
    .rightBox {
        display: flex;
        height: 100%;
        .rightChart {
            width: 280px;
            margin-right: 15px;
            position: relative;
            height: 100%;
            .jgBox {
                position: absolute;
                top: 0;
                height: 46vh;
                left: 0;
                right: 0;
            }
            .rzBox {
                position: absolute;
                bottom: 0;
                height: 36vh;
                left: 0;
                right: 0;
            }
            .heBox {
                height: 36vh;
            }
            .chartTitles {
                color: #00d2ff;
                font-size: 16px;
                padding-left: 15px;
                margin-top: 30px;
            }
            .chartBox {
                display: flex;
                flex-wrap: wrap;
                text-align: center;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                padding: 10px;
                height: 40vh;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                }
                .chartItem {
                    width: 50%;
                    margin-bottom: 20px;
                }
            }
            #huli {
                width: 100%;
                height: 18vh;
            }
            #lodLiveEcharts {
                width: 100%;
                height: 20vh;
            }
        }
        .rightTable {
            flex: 1;
            height: 100%;
            position: relative;
            .rzBoxs {
                position: absolute;
                top: 100px;
                height: 34vh;
                left: 0;
                right: 0;
            }
            .safeBox {
                position: absolute;
                bottom: 0;
                height: 36vh;
                left: 0;
                right: 0;
            }
            .mechanismNum {
                padding: 10px;
                height: 78px;
                border: 1px solid rgba(34, 236, 255, 1);
                background: #01117b;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #6483ff;
                font-size: 16px;
                .mechanismItem {
                    flex: 1;
                }
                .mechanismItem2 {
                    flex: 2;
                }
                .name {
                    color: #22f7ff;
                    font-size: 18px;
                    font-weight: bold;
                }
                .nums {
                    margin-top: 10px;
                    span {
                        color: #cb9537;
                        font-size: 26px;
                    }
                }
                .imgs {
                    width: 19px;
                    height: 19px;
                    margin-right: 6px;
                }
            }
            .houseBox {
                height: 100%;
                overflow: hidden;
                width: 500px;
                .houseList {
                    margin-top: 20px;

                    .houseBar {
                        line-height: 25px;
                        font-size: 13px;
                        color: #0090ff;
                        display: flex;
                        text-align: center;
                        padding-top: 15px;
                    }
                    .flexs {
                        display: flex;
                        p {
                            flex: 1;
                        }
                    }
                    .houseContent {
                        overflow: hidden;
                        margin-top: 10px;
                        height: 63vh;
                        .houseItem {
                            line-height: 25px;
                            font-size: 13px;
                            color: #e4e4e4;
                            display: flex;
                            text-align: center;
                            align-items: center;
                            background: rgba(255, 255, 255, 0.05);
                            margin-top: 25px;
                        }
                        .flexs {
                            display: flex;
                            p {
                                flex: 1;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                    .names {
                        width: 60px;
                    }
                    .ages {
                        width: 40px;
                    }
                    .sex {
                        width: 40px;
                    }
                    .times {
                        width: 80px;
                    }
                    .level {
                        width: 80px;
                        .color1 {
                            color: #7fd42d;
                        }
                        .color2 {
                            color: #ffb026;
                        }
                        .color3 {
                            color: #f21b62;
                        }
                        .color4 {
                            color: #d800ff;
                        }
                    }
                    .mechanisms {
                        flex: 1;
                    }
                }
            }
        }
    }
}

.party-map {
    width: 100%;
    /* height: calc(100vh - 20px); */
    height: 100vh;
    /* overflow: hidden; */
    /* overflow: hidden; */
    /* -webkit-box-shadow: inset 0 0 200px 150px #011729;
  box-shadow: inset 0 0 200px 150px #011729; */
}

@keyframes spin {
    50% {
        transform: translate(-50%, -101%) rotate(500deg);
    }
    100% {
        transform: translate(-50%, -101%) rotate(1000deg);
    }
}
.wave-progress {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #01117b;
    margin-left: -35px;
    overflow: hidden;
    position: relative;
    left: 50%;
}
.wave-progress1 {
    border: 2px solid #559715;
}
.wave-progress2 {
    border: 2px solid #ac1f4e;
}
.wave-progress3 {
    border: 2px solid #b98a37;
}
.wave-progress4 {
    border: 2px solid #990cb2;
}
.wave {
    position: relative;
    width: 100%;
    height: 100%;

    border-radius: 50%;
}
.wave1 {
    background-image: linear-gradient(-180deg, #7fd42d 13%, #7fd42d 100%);
}
.wave2 {
    background-image: linear-gradient(-180deg, #ac1f4e 13%, #ac1f4e 100%);
}
.wave3 {
    background-image: linear-gradient(-180deg, #b98a37 13%, #b98a37 100%);
}
.wave4 {
    background-image: linear-gradient(-180deg, #990cb2 13%, #990cb2 100%);
}
.waveNum {
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    padding: 10px 0;
}
.waveTitle {
    font-size: 13px;
    line-height: 20px;
}
.waveTitle1 {
    color: #7fd42d;
}
.waveTitle2 {
    color: #ac1f4e;
}
.waveTitle3 {
    color: #b98a37;
}
.waveTitle4 {
    color: #990cb2;
}
.wave-mask {
    position: absolute;
    width: 200%;
    height: 200%;
    top: 0;
    left: 50%;
    border-radius: 40%;
    transform: translate(-50%, -101%) rotate(0);
    animation: spin 30s linear;
    z-index: 20;
    background-color: #01117b;
}
.num {
    position: absolute;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 16px;
    line-height: 100px;
    font-weight: bold;
    text-align: center;
    z-index: 100;
}
/deep/.mapOpen {
    display: flex;
    width: 700px;
    .mapImg {
        width: 180px;
        height: 180px;
        margin-right: 12px;
    }
    .mapFlex {
        flex: 1;
        color: #474747;
        font-size: 30px;
        .address,
        .info {
            padding-top: 12px;
        }
    }
}
.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-size: 100% 100%;
    // z-index: 100;
}
.quanp {
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 100;
    button {
        padding: 10px;
    }
}
.older-info {
    /deep/.el-dialog__header {
        background: #17378f;
        padding: 20px;
        .el-dialog__title {
            color: #fff;
        }
    }
    /deep/.el-dialog__body {
        background: #01117b;
        .el-form-item__label {
            color: #fff;
        }
        .el-input__inner {
            background-color: #01117b;
            border: 1px solid #17378f;
        }
    }
}
.border1 {
    border: 1px solid #22f7ff;
    margin-top: -1px;
    margin-left: -1px;
    padding: 10px;
}
.mechanism_info {
    /deep/.el-input__inner {
        background-color: #01117b;
        border: 1px solid #17378f;
        color: #fff;
    }
    /deep/.el-form-item__label {
        color: #fff;
    }
}
// ::-webkit-scrollbar{
//     display:?none;/*?Chrome?Safari?*/
// }
</style>
